import types from './types';
import globalTypes from '../types';
import API from '../../lib/api';
import {toast} from 'react-toastify';

export const loadVip = () => async dispatch => {
    const response = await API.call({
        path: '/vip20/get'
    });

    if(response.success)
        dispatch({
            type: types.loaded,
            payload: response.data
        }); 
}

export const redeemFreeplay = game => async dispatch => {
    dispatch({
        type: types.toggleButton,
        payload: 'freeplay'
    });

    const response = await API.call({
        path: '/vip20/freeplay',
        body: {
            game
        }
    });

    dispatch({
        type: types.toggleButton,
        payload: 'freeplay'
    });

    if(response.success) {
        toast.dismiss();
        toast.success(response.message);

        dispatch({
            type: types.bonuses.freeplay,
            payload: response.freeplay
        });

        dispatch({
            type: globalTypes.games.history.add,
            payload: response.transaction
        });
    } else {
        toast.dismiss();
        toast.error(response.error);
    }
}

export const redeemBirthdayBonus = () => async dispatch => {
        dispatch({
        type: types.toggleButton,
        payload: 'birthday_bonus'
    });
}